<button class="btn btn-primary" (click)="dashboard()">
  <i class="bx bx-bar-chart-square"></i> Member Area
</button>
